export default "__VITE_ASSET__jSmgMCaU__"